module.exports = __webpack_public_path__ + "static/media/boat-img-32.73b1df4d.jpg";